import { AgeGate } from './components/AgeGate';
import { ActivePanel } from './components/ActivePanel';
import { TopBar } from './components/TopBar';
import { TouchControls } from './components/TouchControls';
import { ZoneNav } from './components/ZoneNav';
import { WorldCanvas } from './game/WorldCanvas';
import { useGameStore } from './state/gameStore';

export function App() {
  const ageAccepted = useGameStore((state) => state.ageAccepted);
  const setAgeAccepted = useGameStore((state) => state.setAgeAccepted);
  const combat = useGameStore((state) => state.combat);

  if (!ageAccepted) return <AgeGate onEnter={() => setAgeAccepted(true)} />;

  return (
    <main className="game-shell">
      <WorldCanvas />
      <TopBar />
      <div className="world-intro">
        <span>WAVE {combat.wave} · {combat.kills} KO</span>
        <strong>SMASH THE BEAR BOTS!</strong>
        <small className="desktop-control-copy">WASD MOVE · SPACE ATTACK</small>
        <small className="mobile-control-copy">MOVE · TAP FUK! TO ATTACK</small>
      </div>
      <div className="combat-hud" aria-label={`${combat.hp} health remaining`}>
        <span>HP</span>
        <div><i style={{ width: `${combat.hp}%` }} /></div>
        <b>{combat.hp}/{combat.maxHp}</b>
      </div>
      <div className="disclaimer">MARKET DATA ≠ FINANCIAL ADVICE · NO FUNDS MOVE</div>
      <ZoneNav />
      <TouchControls />
      <ActivePanel />
    </main>
  );
}
